
// 业务组织状态
export const GROUP_STATUS_ENU = {
  0: '停用',
  1: '启用',
  2: '未启用'
}

// 业务组职能分类枚举查询编码
export const FUNCTION_TYPE_ENU = 'ZNLX0000'

// 业务组织职能分类枚举查询编码
export const FUNCTION_OPERATION_TYPE_ENU = 'YJLX0000'
